import { useState, type FormEvent } from 'react';

export default function Contact() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setStatusMsg('投稿已提交，我们会尽快审核！');
      form.reset();
      return;
    }

    const textarea = formData.get('content') as string;
    if (textarea && textarea.length > 500) {
      setStatus('error');
      setStatusMsg('投稿内容不能超过500字');
      return;
    }

    formData.delete('phone_alt');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9lj640bdkpk99j7g160', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setStatus('success');
        setStatusMsg('投稿已提交，我们会尽快审核！');
        form.reset();
      } else {
        const serverMsg = (parsed && (parsed as Record<string, unknown>).meta && ((parsed as Record<string, unknown>).meta as Record<string, unknown>).message) as string
          || (parsed && (parsed as Record<string, unknown>).message) as string
          || responseText;
        if (serverMsg && serverMsg.includes('spam')) {
          setStatus('success');
          setStatusMsg('投稿已提交，我们会尽快审核！');
          form.reset();
          return;
        }
        setStatus('error');
        setStatusMsg(serverMsg || '提交失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请检查网络后重试');
    }
  };

  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[700px] mx-auto">
        <div className="text-center mb-8">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-500 mb-2">Contact</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">投稿爆料</h2>
          <p className="text-sm text-foreground-500 mt-2">有独家线索？欢迎匿名投稿，我们严格保护您的隐私</p>
        </div>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8 space-y-4"
        >
          <div className="honeypot-field">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-1.5">投稿类型</label>
            <select name="type" className="w-full bg-background-50 border border-background-300 rounded-lg px-3 py-2.5 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 transition-colors">
              <option value="">请选择投稿类型</option>
              <option value="独家爆料">独家爆料</option>
              <option value="线索提供">线索提供</option>
              <option value="辟谣申诉">辟谣申诉</option>
              <option value="商务合作">商务合作</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-1.5">投稿标题</label>
            <input
              type="text"
              name="title"
              required
              placeholder="简要描述您的爆料内容"
              className="w-full bg-background-50 border border-background-300 rounded-lg px-3 py-2.5 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-1.5">详细内容（限500字）</label>
            <textarea
              name="content"
              required
              rows={5}
              maxLength={500}
              placeholder="请详细描述您要爆料的事件，包括时间、人物、地点等关键信息..."
              className="w-full bg-background-50 border border-background-300 rounded-lg px-3 py-2.5 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
            ></textarea>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-1.5">联系方式（选填，严格保密）</label>
            <input
              type="email"
              name="email"
              placeholder="您的邮箱，方便我们联系反馈"
              className="w-full bg-background-50 border border-background-300 rounded-lg px-3 py-2.5 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
            />
          </div>

          <button
            type="submit"
            className="whitespace-nowrap w-full bg-primary-500 text-background-50 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-fill mr-2"></i>提交投稿
          </button>

          {status !== 'idle' && (
            <div className={`text-sm text-center p-3 rounded-lg ${
              status === 'success' ? 'bg-primary-50 text-primary-700' : 'bg-accent-100 text-accent-800'
            }`}>
              {status === 'success' && <i className="ri-check-line mr-1"></i>}
              {status === 'error' && <i className="ri-error-warning-line mr-1"></i>}
              {statusMsg}
            </div>
          )}
        </form>
      </div>
    </section>
  );
}